import React from 'react';

import type { MenuDayItemDto } from '@core/interfaces/api';

import { sanitizeMenuItems } from './menu-item-utils';

interface MenuMealProps {
  title: string;
  items: MenuDayItemDto[];
}

function MenuMeal({ title, items }: MenuMealProps) {
  const filteredItems = sanitizeMenuItems(items);

  if (!filteredItems.length) {
    return null;
  }

  return (
    <div className="flex h-full flex-col bg-white py-6 px-4 mb-4">
      <h2 className="text-gray-800 text-center font-bold font-sans text-2xl break-words mb-2">
        {title}
      </h2>
      <div className="flex w-full flex-col gap-1 overflow-y-auto [&::-webkit-scrollbar]:hidden">
        {filteredItems.map((item) => (
          <p
            key={`${item.RecipeId}-${item.RecipeName}`}
            className="text-center text-xl leading-relaxed text-gray-800"
          >
            {item.RecipeName}
          </p>
        ))}
      </div>
    </div>
  );
}

export { MenuMeal, type MenuMealProps };
